"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OriginalI18nProvider", {
  enumerable: true,
  get: function get() {
    return _reactI18next.I18nextProvider;
  }
});
Object.defineProperty(exports, "useTranslation", {
  enumerable: true,
  get: function get() {
    return _reactI18next.useTranslation;
  }
});
Object.defineProperty(exports, "Trans", {
  enumerable: true,
  get: function get() {
    return _reactI18next.Trans;
  }
});
Object.defineProperty(exports, "withTranslation", {
  enumerable: true,
  get: function get() {
    return _reactI18next.withTranslation;
  }
});
Object.defineProperty(exports, "i18nInit", {
  enumerable: true,
  get: function get() {
    return _i18next.default;
  }
});
Object.defineProperty(exports, "i18n", {
  enumerable: true,
  get: function get() {
    return _i18next.default;
  }
});
exports.i18nProviderHOC = exports.I18nProvider = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _invariant = _interopRequireDefault(require("invariant"));

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextXhrBackend = _interopRequireDefault(require("i18next-xhr-backend"));

var _i18nextPseudo = _interopRequireDefault(require("i18next-pseudo"));

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

var _constants = require("./constants");

var _utils = require("./utils");

var _detector = require("./detector");

var _DateLocalization = require("./DateLocalization");

var _format = require("./format");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var I18nProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(I18nProvider, _React$Component);

  var _super = _createSuper(I18nProvider);

  function I18nProvider() {
    (0, _classCallCheck2.default)(this, I18nProvider);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(I18nProvider, [{
    key: "getNamespaceByFileName",
    value: function getNamespaceByFileName(data, url) {
      // ng-translate will merge keys of all dynamically added namespaces into one object
      // to avoid overriding we need to put namespace's keys to additional property
      // for example json structure for "document" namespace should be {"document": {...}}
      // but we don't need it for i18n. This method should unwrap keys.
      var ns = url.slice(url.lastIndexOf('/') + 1).split('.')[0];
      return JSON.parse(data)[ns];
    }
  }, {
    key: "initializeI18n",
    value: function initializeI18n() {
      var _this$props = this.props,
          lang = _this$props.lang,
          nameSpaces = _this$props.nameSpaces,
          resourceUrl = _this$props.resourceUrl,
          environment = _this$props.environment,
          defaultNamespace = _this$props.defaultNamespace,
          enableAutodetect = _this$props.enableAutodetect,
          autodetectWhitelist = _this$props.autodetectWhitelist,
          keySeparator = _this$props.keySeparator,
          nsSeparator = _this$props.nsSeparator,
          pluralSeparator = _this$props.pluralSeparator,
          contextSeparator = _this$props.contextSeparator,
          resources = _this$props.resources,
          debug = _this$props.debug,
          fallbackNS = _this$props.fallbackNS,
          pseudolocalizationEnabled = _this$props.pseudolocalizationEnabled;
      var lng = enableAutodetect ? null : lang;
      (0, _invariant.default)(enableAutodetect && autodetectWhitelist || !enableAutodetect, 'You can\'t enable autodetect without passing autodetectWhitelist');

      if (_i18next.default.isInitialized) {
        return _i18next.default;
      }

      _i18next.default.use(_i18nextXhrBackend.default).use(_reactI18next.initReactI18next);

      var pseudolocalization = pseudolocalizationEnabled || (0, _utils.pseudolocalizationConfiguration)();

      if (pseudolocalization) {
        _i18next.default.use(new _i18nextPseudo.default({
          languageToPseudo: lang,
          letterMultiplier: pseudolocalization,
          enabled: true
        }));
      }

      if (enableAutodetect) {
        var languageDetector = new _i18nextBrowserLanguagedetector.default();
        languageDetector.addDetector((0, _detector.getDetector)(lang));

        _i18next.default.use(languageDetector);
      }

      var preparedLocalesUrl = (0, _utils.prepareLocalesUrl)(resourceUrl, environment);
      return _i18next.default.init({
        lng: lng,
        ns: nameSpaces,
        load: 'currentOnly',
        debug: debug,
        resources: resources,
        backend: {
          loadPath: "".concat(preparedLocalesUrl, "/{{lng}}/{{ns}}.json"),
          parse: this.getNamespaceByFileName,
          crossDomain: true
        },
        detection: {
          order: [_constants.DETECTOR_NAME],
          checkWhitelist: true
        },
        defaultNS: defaultNamespace || nameSpaces[0],
        fallbackNS: fallbackNS,
        fallbackLng: _constants.DEFAULT_LANGUAGE,
        interpolation: {
          escapeValue: false,
          // not needed for react
          format: _format.format
        },
        whitelist: autodetectWhitelist,
        react: {
          useSuspense: false,
          transKeepBasicHtmlNodesFor: ['br']
        },
        keySeparator: keySeparator,
        nsSeparator: nsSeparator,
        pluralSeparator: pluralSeparator,
        contextSeparator: contextSeparator,
        postProcess: ['pseudo']
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      this.initializeI18n();
      return /*#__PURE__*/_react.default.createElement(_reactI18next.I18nextProvider, null, /*#__PURE__*/_react.default.createElement(_DateLocalization.DateLocalizationProvider, null, children));
    }
  }]);
  return I18nProvider;
}(_react.default.Component);

exports.I18nProvider = I18nProvider;
(0, _defineProperty2.default)(I18nProvider, "propTypes", {
  children: _propTypes.default.node,
  lang: _propTypes.default.string,
  nameSpaces: _propTypes.default.arrayOf(_propTypes.default.string),
  resourceUrl: _propTypes.default.string.isRequired,
  environment: _propTypes.default.string,
  defaultNamespace: _propTypes.default.string,
  enableAutodetect: _propTypes.default.bool,
  autodetectWhitelist: _propTypes.default.arrayOf(_propTypes.default.string),
  keySeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  nsSeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  pluralSeparator: _propTypes.default.string,
  contextSeparator: _propTypes.default.string,
  resources: _propTypes.default.object,
  debug: _propTypes.default.bool,
  fallbackNS: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string, _propTypes.default.bool]),
  pseudolocalizationEnabled: _propTypes.default.number
});
(0, _defineProperty2.default)(I18nProvider, "defaultProps", {
  lang: _constants.DEFAULT_LANGUAGE,
  children: null,
  defaultNamespace: _constants.DEFAULT_NAMESPACES[0],
  nameSpaces: _constants.DEFAULT_NAMESPACES,
  enableAutodetect: false,
  autodetectWhitelist: null,
  keySeparator: '.',
  nsSeparator: ':',
  pluralSeparator: '_',
  contextSeparator: '_',
  resources: undefined,
  debug: false,
  fallbackNS: false,
  environment: null,
  pseudolocalizationEnabled: 0
});

var i18nProviderHOC = function i18nProviderHOC(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(I18nProvider, null, /*#__PURE__*/_react.default.createElement(_DateLocalization.DateLocalizationProvider, null, /*#__PURE__*/_react.default.createElement(Component, props)));
  };
};

exports.i18nProviderHOC = i18nProviderHOC;
var _default = I18nProvider;
exports.default = _default;